import * as React from 'react';
import { DefaultView, defaultView } from "../HOC";
import { WithStyles, Theme, createStyles, withStyles, Paper, Typography, LinearProgress, Button, MenuItem, Select, IconButton, Menu, ListItemIcon, ListItemText } from "@material-ui/core";
import { SubAccount, errorToString, ClientsAPI } from "src/api";
import { Responsive } from 'react-grid-layout';
import WidthProvider, { IWidthProvider } from '../HOC/WidthProvider';
import 'react-grid-layout/css/styles.css'
import 'react-resizable/css/styles.css'
import { KleerReportComponentClass, KleerReportComponent } from '.';
import classNames from 'classnames';
import Measure from 'react-measure';
import './Report.css'
import { SaveAlt, Fullscreen, DeleteSweepOutlined, Add } from '@material-ui/icons';
import strings from 'src/strings';
import { Report, ReportSection, DXDatasource } from 'src/api/endpoints/client';
import * as moment from 'moment'
import ReportComponentChart from '../ReportComponents/ReportComponentChart';
import CityBar from '../ReportComponents/CityBar'
import PieDevice from '../ReportComponents/PieDevice'
import StackedLanding from '../ReportComponents/StackedLanding'
import SankeyPages from '../ReportComponents/SankeyPages'
import LineBreakdown from '../ReportComponents/LineBreakdown'
import TreeChannel from '../ReportComponents/TreeChannel'
import AreaChannel from '../ReportComponents/AreaChannel'
// import GaAdsLineBreakdown from '../ReportComponents/GaAdsLineBreakdown'
import LineTopLandingPages from '../ReportComponents/LineTopLandingPages'
import TableOrganic from '../ReportComponents/TableOrganic'
import TableReferral from '../ReportComponents/TableReferral'
import TablePaidSearch from '../ReportComponents/TablePaidSearch'
import TableSocial from '../ReportComponents/TableSocial'
import StackedLineSocial from '../ReportComponents/StackedLineSocial'
import LineKPIHighlights from '../ReportComponents/LineKPIHighlights'
import LineChannelSummary from '../ReportComponents/LineChannelSummary'
import ScatterConversion from '../ReportComponents/ScatterConversion'
import ScatterSession from '../ReportComponents/ScatterSession'
import LineReferral from '../ReportComponents/LineReferral'
import LineBarPaidSearch from '../ReportComponents/LineBarPaidSearch'
import KeywordCloud from '../ReportComponents/KeywordCloud'
import KeywordCloudTop25 from '../ReportComponents/KeywordCloudTop25'
import TableKeyword from '../ReportComponents/TableKeyword'
// import TableGaadsMetrics from '../ReportComponents/TableGaadsMetrics'
import ComponentCommunicator from '../ComponentCommunicator';
import PieSocial from "../ReportComponents/PieSocial";
import TableGAADSCampaign from "../ReportComponents/TableGAADSCampaign";
interface ReportPageProps extends DefaultView<true>, WithStyles<typeof styles> {

}

function createReportComponent(source: DXDatasource): KleerReportComponentClass {
    if (source.type == 'Narrative') {
        // source is of type DXDatasourceNarrative  (source.text)
        //return ReportComonentNarrative // To be implemented
    } else {
        // source is of type DXDatasourceData
    }
    return ReportComponentChart
}

interface ReportPageState {
    loading: boolean,
    apiCallLoading: boolean
    selectedClient?: SubAccount,
    start_index: number,
    end_index: number,
    clients?: SubAccount[],
    report?: ReportSection
    layout?: any
    hiddenGraphs: string[],
    hiddenGraphsAnchor?: any
}
type DefaultGraphConfig = { report: DXDatasource, initialWidth: number, component: KleerReportComponentClass, initialHeight?: number };

const ResponsiveGridLayout = WidthProvider(Responsive);

function getGraphs(report: ReportSection, hiddenGraphs: string[]): DefaultGraphConfig[] {
    return report.components.map(r => {
        return { report: r, component: createReportComponent(r), initialWidth: r.location.width, initialHeight: r.location.height }
    }).filter(graph => {
        return !hiddenGraphs.includes(graph.report.id)
    }).sort((graph1, graph2) => {
        return (graph1.report.location.row - graph2.report.location.row)
    })
}

class ReportPage extends React.Component<ReportPageProps, ReportPageState> {
    // private renderedGraphs: { [key: string]: KleerReportComponent } = {}
    private grid?: IWidthProvider

    constructor(props: ReportPageProps) {
        super(props);
        this.state = {
            loading: true,
            apiCallLoading: false,
            start_index: this.getWeekIndexSource().reverse()[0].index - 3,
            end_index: this.getWeekIndexSource().reverse()[0].index - 1,
            hiddenGraphs: []
        }
        this.onHeaderResize = this.onHeaderResize.bind(this)
    }

    loadReports(client?: SubAccount) { //? means optional parameter
        if (client) {
            window.location.hash = client.id
            this.setState({ loading: true, selectedClient: client })
            ClientsAPI.getReportSection(client, 'f29d77b2-cbe4-408f-888a-54df510fec98', this.state.start_index, this.state.end_index).then(report => {
                this.setState({ report, loading: false, layout: getMetricGridLayout(getGraphs(report, [])), hiddenGraphs: [] })
            }).catch(err => {
                errorToString(err).forEach(error => {
                    this.props.showToast('error', error)
                })
                this.setState({ loading: false })
            })
        }
    }

    componentDidMount() {
        ComponentCommunicator.instance().addListener('DID_RESIZE', this.onHeaderResize)
        ClientsAPI.getClients().then(clients => { //promise
            let selectedClient: SubAccount | undefined = undefined
            if (window.location.hash) {
                selectedClient = clients.find(t => t.id == window.location.hash.substr(1))
            }
            this.setState({ clients, loading: false }, () => {
                if (selectedClient) {
                    this.loadReports(selectedClient)
                }
            })
        }).catch(err => {
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
            this.setState({ loading: false })
        })
    }

    componentWillUnmount() {
        ComponentCommunicator.instance().removeListener('DID_RESIZE', this.onHeaderResize)
    }

    private onHeaderResize() {
        setImmediate(() => {
            this.grid && this.grid.didResize()
        })
    }

    private hideGraph(config: DefaultGraphConfig) {
        this.setState({ hiddenGraphs: this.state.hiddenGraphs.concat(config.report.id) })
    }

    // private getAvailableGraphs() {
    //     if (this.state.report)
    //         return getGraphs(this.state.report, this.state.hiddenGraphs)
    //     return []
    // }

    private getWeekIndexSource() {
        const max = moment(new Date()).diff(new Date(-2208960000000), 'week')
        const source = []
        for (var i = (max - 50); i <= max; i++) {
            source.push({ index: i, display: moment().add(-(max - i), 'week').format('ww-MMM-YYYY') })
        }
        return source;
    }

    private renderClientSelector() {
        if (this.state.clients && this.state.clients.length > 0) {
            return <div>
                <Select
                    value={(this.state.selectedClient ? this.state.selectedClient.id : '')}
                    className={this.props.classes.clientSelector}
                    autoWidth
                    displayEmpty
                    onChange={(e) => this.loadReports(this.state.clients!.find(c => c.id == e.target.value)!)}
                    inputProps={{ name: 'ip-client' }}>
                    <MenuItem value="" disabled>
                        {strings.client_noClientSelecteed}
                    </MenuItem>
                    {this.state.clients.map(client => {
                        return <MenuItem key={client.id} value={client.id}>{client.name}</MenuItem>
                    })}
                </Select>
                <Select
                    value={(this.state.end_index)}
                    className={this.props.classes.clientSelector}
                    autoWidth
                    displayEmpty
                    onChange={(e) => this.setState({ end_index: parseInt(e.target.value as string) }, () => this.loadReports(this.state.selectedClient))}
                    inputProps={{ name: 'ip-month' }}>
                    {this.getWeekIndexSource().map(item => {
                        return <MenuItem key={item.index} value={item.index}>{item.display}</MenuItem>
                    })}
                </Select>
                <Select
                    value={(this.state.start_index)}
                    className={this.props.classes.clientSelector}
                    autoWidth
                    displayEmpty
                    onChange={(e) => this.setState({ start_index: parseInt(e.target.value as string) }, () => this.loadReports(this.state.selectedClient))}
                    inputProps={{ name: 'ip-month' }}>
                    {this.getWeekIndexSource().map(item => {
                        return <MenuItem key={item.index} value={item.index}>{item.display}</MenuItem>
                    })}
                </Select>
                {!this.state.selectedClient && <div className={this.props.classes.infoContainer}>
                    <Typography variant='subtitle1' style={{ textAlign: 'center' }}>{strings.client_pleaseSelectClient}</Typography>
                </div>}
                {this.state.selectedClient && <IconButton color="inherit" className={this.props.classes.toolbarButton} onClick={() => {
                    // window.open(ClientsAPI.getFullReportPdfLink(this.state.selectedClient!, this.getAvailableGraphs().map(g => g.report), this.state.monthIndex), '__blank')
                }}>
                    <SaveAlt />
                </IconButton>}
                {this.state.hiddenGraphs.length > 0 && <IconButton className={this.props.classes.toolbarButtonHiddenGraphs} color="inherit" onClick={(e) => this.setState({ hiddenGraphsAnchor: e.currentTarget })}>
                    <DeleteSweepOutlined />
                </IconButton>}
                {/* {this.state.selectedClient && <Button className={this.props.classes.toolbarButton} style={{ height: '48px' }} onClick={(e) => {
                    this.setState({ apiCallLoading: true })
                    ClientsAPI.saveClientView(this.state.selectedClient!, { hiddenGraphs: this.state.hiddenGraphs, layout: this.state.layout }).then(() => {
                        this.setState({ apiCallLoading: false })
                    }).catch(err => {
                        errorToString(err).forEach(error => {
                            this.props.showToast('error', error)
                        })
                        this.setState({ apiCallLoading: false })
                    })
                }}>
                    Save View
            </Button>} */}
                {this.state.selectedClient && <Button className={this.props.classes.toolbarButton} style={{ height: '48px' }} onClick={(e) => {
                    this.setState({ apiCallLoading: true })
                    /*ClientsAPI.emailReport(this.state.selectedClient!, this.getAvailableGraphs().map(g => g.report), this.state.monthIndex).then(() => {
                        this.setState({ apiCallLoading: false })
                    }).catch(err => {
                        errorToString(err).forEach(error => {
                            this.props.showToast('error', error)
                        })
                        this.setState({ apiCallLoading: false })
                    })*/
                }}>
                    Email Report
            </Button>}
                <Menu
                    id="hidden-graph-menu"
                    anchorEl={this.state.hiddenGraphsAnchor}
                    open={Boolean(this.state.hiddenGraphsAnchor)}
                    onClose={() => { this.setState({ hiddenGraphsAnchor: undefined }) }}>
                    {this.state.hiddenGraphs.map((graph, i) => {
                        if (this.state.report) {
                            let name = this.state.report!.components.find(comp => {
                                return comp.id == graph
                            })!.title
                            return <MenuItem key={i.toString()} onClick={() => {
                                let hiddenGraphs = this.state.hiddenGraphs;
                                hiddenGraphs = hiddenGraphs.filter(g => {
                                    return g != graph
                                })
                                this.setState({ hiddenGraphs, hiddenGraphsAnchor: undefined })
                            }}>
                                <ListItemIcon>
                                    <Add />
                                </ListItemIcon>
                                <ListItemText>{name}</ListItemText>
                            </MenuItem>
                        }
                        return null
                    })}
                </Menu>
            </div>
        } else if (!this.state.loading) {
            return <div className={this.props.classes.infoContainer}>
                <Typography variant='subtitle1' style={{ textAlign: 'center' }}>{strings.client_noClientsYet}</Typography>
                <Button variant='outlined' onClick={(e) => this.props.history.push('/app/clients')}>{strings.client_addFirstClient}</Button>
            </div>
        } else {
            return <></>
        }
    }

    private onSizeKnown(report: DXDatasource, height: number) {

    }


    public render() {
        // this.renderedGraphs = {}
        return (
            <>

                {this.state.loading || this.state.apiCallLoading && <LinearProgress />}
                <div style={{ height: 60 }}>
                    {this.renderClientSelector()}
                </div>


                <Paper>
                    <div style={{ display: 'flex', margin: 'auto', justifyContent: 'space-around' }}>
                        {/* <PieDevice client={this.state.selectedClient}/> */}
                        <PieSocial client={this.state.selectedClient} />
                    </div>
                </Paper>
                <TreeChannel client={this.state.selectedClient} />
                <TableOrganic client={this.state.selectedClient} />
                <TableReferral client={this.state.selectedClient} />
                <TablePaidSearch client={this.state.selectedClient} />
                <KeywordCloudTop25 client={this.state.selectedClient} />
                <TableKeyword client={this.state.selectedClient} />
                <TableSocial client={this.state.selectedClient} />
                <TableGAADSCampaign client={this.state.selectedClient} />
                {/* <TableGaadsMetrics client={this.state.selectedClient} /> */}

                <ScatterConversion client={this.state.selectedClient} />
                <ScatterSession client={this.state.selectedClient} />
                <KeywordCloud client={this.state.selectedClient} />

                <AreaChannel client={this.state.selectedClient} /> 
                <LineTopLandingPages client={this.state.selectedClient} />
                <LineReferral client={this.state.selectedClient}/>
                <LineBarPaidSearch client={this.state.selectedClient}/>

                <Paper>
                    <CityBar client={this.state.selectedClient} />

                </Paper>
                <Paper>
                    <StackedLanding client={this.state.selectedClient}/>

                </Paper>
                <Paper>
                   
                    <SankeyPages client={this.state.selectedClient} />

                </Paper>
                <Paper>
                    {/* <LineBreakdown client={this.state.selectedClient} /> */}
                </Paper>
                <Paper>
                    {/* <GaAdsLineBreakdown client={this.state.selectedClient}/> */}
                </Paper>


                <div>
                    <StackedLineSocial client={this.state.selectedClient}/>
                    <LineKPIHighlights client={this.state.selectedClient}/>
                    <LineChannelSummary client={this.state.selectedClient}/>
                </div>

            </>
        )

    }
}

const styles = (theme: Theme) => createStyles({
    paper: {
        ...theme.mixins.gutters(),
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
        paddingRight: theme.spacing(2)
    },
    graphPaper: {
        paddingTop: theme.spacing() + 'px !important',
        paddingRight: theme.spacing() + 'px !important'
    },
    toolBarButton: {
        maxWidth: 40,
        minWidth: 40,
        padding: 0
    },
    infoContainer: {
        position: 'absolute', left: '50%', top: '50%',
        transform: 'translate(-50%, -50%)'
    },
    grid: {
    },
    clientSelector: {
        height: 48,
        float: 'right',
        marginRight: theme.spacing()
    },
    toolbarButton: {
        float: 'right',
        marginRight: theme.spacing(2)
    },
    toolbarButtonHiddenGraphs: {
        float: 'right',
        marginRight: theme.spacing()
    }
});

export default defaultView(withStyles(styles)(ReportPage), true) as React.ComponentClass

const MAXIMUM_COLS = 4
function getMetricGridLayout(graphs: ({ report: DXDatasource })[]) {
    const largeLaylout = graphs.map((comp, i) => {
        let t = {
            i: i.toString(),
            x: comp.report.location.row,
            y: comp.report.location.col,
            w: comp.report.location.width,
            h: comp.report.location.height
        }
        return t
    })
    const smallLaylout = largeLaylout
    // console.log(largeLaylout)
    const layout = {
        lg: largeLaylout,
        md: largeLaylout,
        sm: smallLaylout,
        xs: smallLaylout,
        xxs: smallLaylout
    }
    return layout
}

// function getGridConfiguration() {
//     return {
//         breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
//         cols: { lg: MAXIMUM_COLS, md: MAXIMUM_COLS, sm: 1, xs: 1, xxs: 1 }
//     }
// }


// WEBPACK FOOTER //
// ./src/components/Report/ReportCopy.tsx